"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var colors_1 = require("../colors");
var Secure = function (_a) {
    var type = _a.type, width = _a.width, height = _a.height, fill = _a.fill;
    switch (type) {
        case 'line':
        default:
            return (React.createElement("svg", { width: width, height: height, viewBox: "0 0 40 40", fill: "none" },
                React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.5455 4.54547L6.36365 10.3306V19.0083C6.36365 27.0351 11.9879 34.5413 19.5455 36.3637C27.103 34.5413 32.7273 27.0351 32.7273 19.0083V10.3306L19.5455 4.54547ZM19.5455 20.1654H29.5317C29.0923 26.074 25.0066 31.1817 19.5455 32.4834V20.1654H9.55924V13.0369L19.5455 8.42574V20.1654Z", fill: fill })));
    }
};
Secure.propTypes = {
    type: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    fill: PropTypes.string,
};
Secure.defaultProps = {
    type: 'solid',
    width: 40,
    height: 40,
    fill: colors_1.grey5,
};
exports.default = Secure;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2VjdXJlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2ljb25zL1NlY3VyZS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSw2QkFBK0I7QUFDL0Isc0NBQXdDO0FBRXhDLG9DQUFnQztBQVFoQyxJQUFNLE1BQU0sR0FBMEIsVUFBQyxFQUEyQjtRQUExQixjQUFJLEVBQUUsZ0JBQUssRUFBRSxrQkFBTSxFQUFFLGNBQUk7SUFDL0QsUUFBUSxJQUFJLEVBQUU7UUFDWixLQUFLLE1BQU0sQ0FBQztRQUNaO1lBQ0UsT0FBTyxDQUNMLDZCQUFLLEtBQUssRUFBRSxLQUFLLEVBQUUsTUFBTSxFQUFFLE1BQU0sRUFBRSxPQUFPLEVBQUMsV0FBVyxFQUFDLElBQUksRUFBQyxNQUFNO2dCQUNoRSw4QkFDRSxRQUFRLEVBQUMsU0FBUyxFQUNsQixRQUFRLEVBQUMsU0FBUyxFQUNsQixDQUFDLEVBQUMsMFJBQTBSLEVBQzVSLElBQUksRUFBRSxJQUFJLEdBQ1YsQ0FDRSxDQUNQLENBQUM7S0FDTDtBQUNILENBQUMsQ0FBQztBQUVGLE1BQU0sQ0FBQyxTQUFTLEdBQUc7SUFDakIsSUFBSSxFQUFFLFNBQVMsQ0FBQyxNQUFhO0lBQzdCLEtBQUssRUFBRSxTQUFTLENBQUMsU0FBUyxDQUFDLENBQUMsU0FBUyxDQUFDLE1BQU0sRUFBRSxTQUFTLENBQUMsTUFBTSxDQUFDLENBQVE7SUFDdkUsTUFBTSxFQUFFLFNBQVMsQ0FBQyxTQUFTLENBQUMsQ0FBQyxTQUFTLENBQUMsTUFBTSxFQUFFLFNBQVMsQ0FBQyxNQUFNLENBQUMsQ0FBUTtJQUN4RSxJQUFJLEVBQUUsU0FBUyxDQUFDLE1BQU07Q0FDdkIsQ0FBQztBQUVGLE1BQU0sQ0FBQyxZQUFZLEdBQUc7SUFDcEIsSUFBSSxFQUFFLE9BQU87SUFDYixLQUFLLEVBQUUsRUFBRTtJQUNULE1BQU0sRUFBRSxFQUFFO0lBQ1YsSUFBSSxFQUFFLGNBQUs7Q0FDWixDQUFDO0FBRUYsa0JBQWUsTUFBTSxDQUFDIn0=


//////////////////
// WEBPACK FOOTER
// ./node_modules/@riiid/santa-closet-web/icons/Secure.js
// module id = 94
// module chunks = 0